// Components
import Form from '../../ComponentLibrary/forms/oc-form';
import Fieldset from '../../ComponentLibrary/input-elements/oc-fieldset';
import FormButton from '../../ComponentLibrary/input-elements/oc-form-button';
import RadioButton from '../../ComponentLibrary/input-elements/oc-radio-button';
import TextInput from '../../ComponentLibrary/input-elements/oc-text-input';
import { H3 } from '../../ComponentLibrary/text-elements/oc-h';

// eslint-disable-next-line react/prop-types
const ProCatForm = ({ formSubmit, inputChange, input }) => (
  <Form onSubmit={formSubmit}>
    <H3 font="body" underline>
      Calculating Inputs
    </H3>

    <Fieldset margin="16px 0">
      <TextInput
        name="atticSqFt"
        inputType="number"
        label="Attic Sq. Ft."
        touched
        error={input.sqFtError}
        onChange={inputChange}
        value={input.atticSqFt}
      />
    </Fieldset>

    <Fieldset margin="0 0 16px">
      <TextInput
        name="currentDepth"
        inputType="number"
        label="Current Insulation Depth (in)"
        touched
        error={input.currentDepthError}
        onChange={inputChange}
        value={input.currentDepth}
      />
    </Fieldset>

    <Fieldset margin="0 0 32px" horizontal legend="DOE Recommended R-Value" onChange={inputChange}>
      <RadioButton name="rvalue" value="R38" checked={input.rvalue === 'R38'}>
        R38
      </RadioButton>
      <RadioButton name="rvalue" value="R49" checked={input.rvalue === 'R49'}>
        R49
      </RadioButton>
      <RadioButton name="rvalue" value="R60" checked={input.rvalue === 'R60'}>
        R60
      </RadioButton>
    </Fieldset>

    <H3 font="body" underline>
      Calculating Costs
    </H3>

    <Fieldset margin="16px 0">
      <TextInput
        name="costPerBag"
        inputType="number"
        label="Cost Per Bag"
        touched
        onChange={inputChange}
        value={input.costPerBag}
      />
    </Fieldset>

    <Fieldset margin="0 0 16px">
      <TextInput
        name="installers"
        inputType="number"
        label="Installers"
        touched
        error=""
        onChange={inputChange}
        value={input.installers}
      />
    </Fieldset>

    <Fieldset margin="0 0 16px">
      <TextInput
        name="laborCost"
        inputType="number"
        label="Labor Cost (per hour)"
        touched
        error=""
        onChange={inputChange}
        value={input.laborCost}
      />
    </Fieldset>

    <Fieldset margin="0 0 16px">
      <TextInput
        name="markup"
        inputType="number"
        label="Desired Markup (%)"
        touched
        error=""
        onChange={inputChange}
        value={input.markup}
      />
    </Fieldset>

    <Fieldset margin="0 0 16px">
      <FormButton
        buttonType="submit"
        data-track="form-submit"
        data-track-form-name="PinkBar vs Steel"
        data-track-form-type="Calculator"
        data-track-form-details="[laborCost]"
      >
        Calculate Amount
      </FormButton>
    </Fieldset>
  </Form>
);

export default ProCatForm;
